import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, X } from 'lucide-react';
export function WhoIsThisFor() {
  const forYou = ['Eres mujer de 45 años o más en etapa de perimenopausia o menopausia', 'Sufres de sofocos nocturnos, irritabilidad y falta de enfoque', 'Eres mujer latina que busca una solución natural y holística antes que fármacos químicos', 'Eres profesional o ama de casa que necesita recuperar su energía vital para rendir en el día'];
  const notForYou = ["Buscas una 'pastilla mágica' que funcione sin cambiar hábitos básicos", 'No estás dispuesta a invertir 15 minutos al día en tu propio bienestar', 'Eres hombre o mujer menor de 35 años (esta química es específica para la madurez femenina)'];
  return <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto" data-id="element-174">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-175">
        <FadeIn data-id="element-176">
          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-green-100 h-full" data-id="element-177">
            <h3 className="text-2xl font-serif font-bold text-warm-dark mb-6 flex items-center" data-id="element-178">
              <span className="bg-green-100 text-green-700 p-2 rounded-full mr-3" data-id="element-179">
                <Check className="w-6 h-6" data-id="element-180" />
              </span>
              Para Ti Si...
            </h3>
            <ul className="space-y-5" data-id="element-181">
              {forYou.map((item, index) => <li key={index} className="flex items-start space-x-3" data-id="element-182">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" data-id="element-183" />
                  <span className="text-warm-dark/80 font-sans" data-id="element-184">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-185">
          <div className="bg-blush/20 p-8 md:p-10 rounded-3xl border border-blush/50 h-full" data-id="element-186">
            <h3 className="text-2xl font-serif font-bold text-warm-dark mb-6 flex items-center" data-id="element-187">
              <span className="bg-red-100 text-red-700 p-2 rounded-full mr-3" data-id="element-188">
                <X className="w-6 h-6" data-id="element-189" />
              </span>
              No Es Para Ti Si...
            </h3>
            <ul className="space-y-5" data-id="element-190">
              {notForYou.map((item, index) => <li key={index} className="flex items-start space-x-3" data-id="element-191">
                  <X className="w-5 h-5 text-red-500/70 flex-shrink-0 mt-1" data-id="element-192" />
                  <span className="text-warm-dark/80 font-sans" data-id="element-193">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}